import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

const LastUpdatedIndicator = ({ date }) => {
    const lastUpdated = moment(date).format('DD MMM YYYY, hh:mm A');
    return (
        <div className="last-updated-indicator">
            <div className="d-inline-flex d-flex">
                <div className="indicator-image">
                    <img src="/resources/themes/forsythbarr/dist/media/last-update-indicator.svg" width="30"
                        height="30" alt="last update indicator" />
                </div>
                <div className="last-updated">
                    <p>{lastUpdated} NZT</p>
                    <p>All stock prices and news delayed 20 minutes</p>
                </div>
            </div>
        </div>
    );
};

LastUpdatedIndicator.propTypes = {
    date: PropTypes.string,
};
export default LastUpdatedIndicator;
